//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import InquiryForm from '~/components/search/inquiry/mixins/InquiryForm'

import { validationMixin } from 'vuelidate'
import {email, required, minLength, maxLength, url, sameAs} from "vuelidate/lib/validators"
import { BFormGroup, BFormInput, BFormSelect } from 'bootstrap-vue'

import Multiselect from 'vue-multiselect'

export default {

    name: 'InquiryContact',

    mixins: [validationMixin, InquiryForm],

    components: { BFormGroup, BFormInput, BFormSelect, Multiselect },

    props: {
        contact: {
        },
        countries: {
        }
    },

    data() {
      return {
      }
    },

    validations: {
        contact: {
            company: {
                required
            },
            phoneNumber: {
                required
            },
            firstName: {
                required
            },
            lastName: {
                required
            },
            jobTitle: {
                required
            },
            country: {
                required
            },
            email: {
                required,
                email
            },
            emailConfirm: {
                required,
                email,
                sameAsEmail: sameAs('email')
            },
        }
    },

}

